import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n';
import { initWhatsAppGa4Tracking } from './services/trackingService';

initWhatsAppGa4Tracking();

const rootElement = document.getElementById('root')!;

const initialGeo = typeof window !== 'undefined' ? (window as any).__GEO_INITIAL__ : undefined;
const initialData = typeof window !== 'undefined' ? (window as any).__INITIAL_DATA__ : undefined;

if (rootElement && rootElement.children.length > 0) {
  hydrateRoot(
    rootElement,
    <StrictMode>
      <App initialGeo={initialGeo} initialData={initialData} />
    </StrictMode>
  );
} else if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <App initialGeo={initialGeo} initialData={initialData} />
    </StrictMode>
  );
}
